import { Routes, mapToCanActivate, mapToResolve } from '@angular/router';
import { LocationGuard } from '@next/core-lib/relationships';

import { BarnItemComponent } from './components/barn-item/barn-item.component';
import { BarnOverviewComponent } from './components/barn-overview/barn-overview.component';
import { DiscountSettingComponent } from './components/discount-setting/discount-setting.component';
import { FarmResultSettingComponent } from './components/farm-result-setting/farm-result-setting.component';
import { FinalSetupSettingComponent } from './components/final-setup-setting/final-setup-setting.component';
import { PerformanceSettingComponent } from './components/performance-setting/performance-setting.component';
import { SettingsOverviewComponent } from './components/settings-overview/settings-overview.component';
import { SustainabilityOverviewComponent } from './components/sustainability-overview/sustainability-overview.component';
import { BarnSelectedGuard } from './guards/barn-selected.guard';
import { SettingsResolver } from './resolvers/settings.resolver';
import { FarmSettingsResolver } from './store/resolvers/farm-settings.resolver';

export const settingsRoutes: Routes = [
  {
    path: 'settings',
    redirectTo: 'settings/finalsetupsetting',
    pathMatch: 'full',
  },
  {
    path: 'settings',
    component: SettingsOverviewComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    children: [
      {
        path: 'barn',
        component: BarnOverviewComponent,
        canActivate: mapToCanActivate([LocationGuard]),
        resolve: {
          isLoaded: mapToResolve(SettingsResolver),
        },
        data: { name: 'barn-overview' },
      },
      {
        path: 'barn/:barnId',
        component: BarnItemComponent,
        canActivate: mapToCanActivate([LocationGuard, BarnSelectedGuard]),
        data: { name: 'barn-item' },
      },
      {
        path: 'performancesetting',
        component: PerformanceSettingComponent,
        canActivate: mapToCanActivate([LocationGuard]),
        data: { name: 'performancesetting' },
      },
      {
        path: 'farmresultsetting',
        component: FarmResultSettingComponent,
        canActivate: mapToCanActivate([LocationGuard]),
        data: { name: 'farmresultsetting' },
      },
      {
        path: 'finalsetupsetting',
        component: FinalSetupSettingComponent,
        canActivate: mapToCanActivate([LocationGuard]),
        resolve: {
          isLoaded: mapToResolve(SettingsResolver),
        },
        data: { name: 'finalsetupsetting' },
      },
      {
        path: 'discountsetting',
        component: DiscountSettingComponent,
        canActivate: mapToCanActivate([LocationGuard]),
        data: { name: 'discountsetting' },
      },
      {
        path: 'sustainabilitysetting',
        component: SustainabilityOverviewComponent,
        canActivate: mapToCanActivate([LocationGuard]),
        resolve: {
          isLoaded: mapToResolve(FarmSettingsResolver),
        },
        data: { name: 'sustainabilitysetting' },
      },
    ],
  },
];
